<template>
  <div class="header-content">
    <img class="logo" v-if="showLogo && theme=='light-theme' && !logoDark" src="/image/logo_dark.png" alt="">
    <img class="logo" v-if="showLogo && theme!='light-theme' && !logoLight" src="/image/logo_light.png" alt="">
    <!--<img class="logo" v-if="showLogo && theme=='light-theme' && logoDark" :src="getRealUrl(logoDark)" alt="">-->
    <!--<img class="logo" v-if="showLogo && theme!='light-theme' && logoLight" :src="getRealUrl(logoLight)" alt="">-->
    <!--标题logo始终显示-->
    <img class="logo" v-if="theme=='light-theme' && logoDark"  src="/image/logo_light_bnerc.png" alt="">
    <img class="logo" v-if="theme!='light-theme' && logoLight" src="/image/logo_light_bnerc.png" alt="">
    <!--标题文字始终显示-->
    <!--<div class="name" v-if="showLogo">{{name}}</div>-->
    <div class="name" :style="theme=='light-theme'?'color:#fff':''">{{name}}</div>
    <div v-if="weather" style="margin-top:10px;"><span style="margin-right:10px;" class="color-light">{{weather.city}}{{$t('天气')}}:</span><img style="width:20px;vertical-align: middle;margin-right:6px;" :src="getImgSrc"><span class="color-normal">{{weather.wea}}  {{weather.tem2}} - {{weather.tem1}}</span></div>
    <div style="display: inline-block;margin-top:5px;" v-if="projectUnits&&projectUnits.length > 0">
      <span class="color-light">{{$t('合作单位')}}:</span>
      <span class="color-normal" v-for="item in projectUnits" style="margin-right:6px;"><img style="max-height:30px;vertical-align: middle" :src="getImgUrl(item.logoUrl)" alt="">{{item.name}}</span>
    </div>
    <div class="block"></div>
    <div class="user-flex" :style="theme=='light-theme'?'color:#fff':''">.
      <header-center-menu />
      <el-tooltip :content="$t('首页')" placement="bottom" effect="light">
        <div style="font-size:16px" @click="goLocation()" class="el-icon-s-home mr20 home"></div>
      </el-tooltip>
      <el-tooltip v-if="bigScrAddr||projectInfo.bigScrAddr" :content="$t('大屏')" placement="bottom" effect="light">
        <i class="iconfont icon-shujudaping mr20" style="font-size:16px" @click="goBigDataLink(bigScrAddr||projectInfo.bigScrAddr)" ></i>
      </el-tooltip>
      <screenfull class="screenfull c_pointer mr20 mt10"></screenfull>
      <div class="warning-bell">
        <el-tooltip placement="bottom" effect="light">
          <div slot="content">
            <warnBox ref="warnBox" :searchFactor="{}" :userInfo="userInfo" :callWarn="$t('报警')" :callWarnNo="$t('没有报警')" @clickItem ="clickItem" />
          </div>
          <div>
            <div class="fa fa-bell-o"></div>
            <div class="warning_tip">{{warningNum<=99?warningNum:"99+"}}</div>
          </div>
        </el-tooltip>
      </div>
      <el-dropdown class="user-info" :style="theme=='light-theme'?'color:#fff':''">
        <div class="el-dropdown-link name-over">
          Hi {{userInfo.name}}
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item><div @click="personCenter">{{$t('个人设置')}}</div></el-dropdown-item>
          <el-dropdown-item v-show="buttonPageObj['createProject']"><div @click="createProject">{{$t('新建项目')}}</div></el-dropdown-item>
          <el-dropdown-item v-if="buttonPageObj['project.list']"><div @click="projectList">{{$t('我的项目')}}</div></el-dropdown-item>
          <el-dropdown-item class="el-dropdown-link" v-show="domainList && domainList.length > 1">
            <div>
              {{ $t('企业切换') }}
            </div>
            <div class="domain-list bg-dark-color border">
              <li class="primary-hover-color" :class="{'active': item.domainPrefix === currentDomain}" v-for="item in domainList" :key="item.domainPrefix" @click="changeDomainPrefix(item.domainPrefix)">{{ item.customName || item.domainPrefix }}</li>
            </div>
          </el-dropdown-item>
          <el-dropdown-item class="el-dropdown-link">
            <div>
              {{ $t('更换皮肤') }}
            </div>
            <div class="domain-list bg-dark-color border">
              <li class="primary-hover-color"  :class="{ 'active': item.value === theme }" v-for="item in themeList" :key="item.value"><span @click="changeTheme(item.value)">{{ item.name}}</span></li>
            </div>
          </el-dropdown-item>
          <el-dropdown-item class="el-dropdown-link">
            <div>
              {{ $t('语言切换') }}
            </div>
            <div class="domain-list bg-dark-color border">
              <li class="primary-hover-color"  :class="{ 'active': item.command === language }"
                  v-for="(item) in languageListComp" @click="switchLang(item.command)" :key="item.command"><span >{{ item.label }}</span></li>
            </div>
          </el-dropdown-item>
          <!-- ====== 设备切换已移除：改为从数据字典 device_mode 读取开关值 ====== -->
          <el-dropdown-item class="el-dropdown-link">
            <div>
              {{ $t('帮助文档') }}
            </div>
            <div class="domain-list bg-dark-color border">
              <li class="primary-hover-color" ><span @click="showDialog = true">{{ $t('意见反馈') }}</span></li>
              <!--                          <li class="primary-hover-color" v-if="helpLink"><span @click="openHelpInfo()">{{ $t('帮助手册') }}</span></li>-->
              <li class="primary-hover-color" ><span @click="openNormalFormula()">{{ $t('常用公式') }}</span></li>
            </div>
          </el-dropdown-item>
          <el-dropdown-item  v-if="showChekedPoint"><div @click="handleShowOrHidderCheckDialog(true)">{{ $t('一键检查') }}</div></el-dropdown-item>

          <el-dropdown-item><div @click="logoutUser">{{$t('退出')}}</div></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <warning-detail v-if="showWarningModal" :showModal.sync="showWarningModal" :status="getStatus" :currentData="currentWarningData" @update="updateStatus"></warning-detail>
    <el-dialog
        v-dialogDrag
        class="feedback_dialog"
        :visible.sync="showDialog"
        width="600px"
        :title="$t('意见反馈')"
        center>
      <div class="weaken_color">{{$t('我们珍视您的每一条反馈，描述越精确的问题，更易得到解决')}}</div>
      <div class="clear_both mt10"></div>
      <feed-back v-if="showDialog" @cancelOperate="showDialog = false;"/>
    </el-dialog>
    <userGuidance @cancelOperate = "changeTheme" v-if="pageConfig && pageConfig.screenAnimation"/>
    <!--        <userGuidance @cancelOperate = "changeTheme" v-if="false"/>-->

    <!-- 一键检查图标 -->
    <!-- <div class="check-btn-wapper" :draggable="true" v-if="showChekedPoint" @click="handleShowOrHidderCheckDialog(true)" @dragend="dragend($event)" ref="checkRef" @mousedown="dragendStart">
      <img src="../assets/check.png" alt="">
    </div> -->
    <!-- 一键检查 -->
    <checkDialog ref="checkDialog"  @close="handleShowOrHidderCheckDialog(false)" v-show="isCheckDialog"  v-CheckfloatDrag="'float-content'" >
      <checkData ref="checkDataRef" @updataCheckPage="updataCheckPage"></checkData>
    </checkDialog>
  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import { getTheme,getToken,getSystemRole} from '@/utils/auth.js'
import {getWeatherImgSrc,getDomainPrefix,imgBaseUrl,contentExtend,goHome,languageList,getCurrentLangLabel, openFloatDialog} from '@/utils/common.js'
import Screenfull from '@/components/Screenfull'

export default {
  data(){
    let _this = this;
    return {
      logoLight:'',
      logoDark:'',
      name:'',
      theme:'',
      projectUnits:[],
      showWarningModal:false,
      currentWarningData:{},
      showDialog:false, //意见反馈
      helpLink:'',
      bigScrAddr:'',
      languageList:languageList,
      themeList:[
        { value: 'light-theme', name: _this.$t('中交蓝') },
        { value: 'dark-theme', name: _this.$t('繁星黑') },
        { value: 'gold-theme', name: _this.$t('奢雅金') },
      ],
      // 一键检查相关
      showChekedPoint:false,
      checkPageCount: false, //是不是第一次展示一键检查弹窗
    }
  },
  props:{
    showLogo:{
      type:Boolean,
      default:false
    }
  },
  components:{
    headerCenterMenu:()=>import("@/layout/headerCenterMenu"),
    Screenfull:contentExtend(Screenfull),
    userGuidance:()=>import('@/layout/userGuidance.vue'),
    checkDialog: () => import("@/components/checkDialog"),
  },
  mounted(){
    this.theme = getTheme()||'light-theme'
    this.setBodyTheme(this.theme)
    let domainPrefix = getDomainPrefix(window.location.pathname)
    this.changeDomainPrefix(domainPrefix || this.currentDomain)
    this.$Bus.$on("setWarningNum", (length) => {
      this.$store.dispatch('setWarningNum', length)
    })

    // 判断是否展示一键检查
    if (this.isSystemRoleAndSelfDoaim()) {
      this.showChekedPoint = true
    } else {
      this.showChekedPoint = false
    }
  },
  watch:{
    pageConfig: {
      handler(newVal) {
        console.log('pageConfig', newVal)
        if (newVal) {
          // this.name = newVal.platformName || this.$t('公路长大桥建设公家工程研究中心')
          this.name =  newVal.platformName || this.$t('藤州浔江大桥')
          this.logoDark = newVal.logoTypeDeep || ''
          this.logoLight = newVal.logoTypeLight || ''
          this.helpLink = newVal.docUrl
          this.bigScrAddr = newVal.universalAddress
        }
      },
      immediate: true,
    },
    projectInfo(newVal,oldVal){
      if(newVal.id != oldVal.id) {
        setTimeout(() => {
          this.getProjectUnits()
        },300)
      }
    }
  },
  computed: {
    getImgSrc(){
      let weaSrc = getWeatherImgSrc(this.weather.wea)
      return weaSrc
    },
    getStatus(){
      switch(this.currentWarningData.status){
        case 0:
          return this.$t('未处理')
          break
        case 1:
          return this.$t('忽略')
          break;
        case 2:
          return this.$t('已上报')
          break;
        case 3:
          return this.$t('已处理')
          break;
      }
    },
    languageListComp() {
      return languageList
    },

    isCheckDialog() {
      return this.$store.state.app.isCheckDialog
    },
    ...mapGetters([
      'userInfo',
      'pageConfig',
      'buttonPageObj',
      'warningNum',
      'projectInfo',
      'language',
      'weather',
      'domainList',
      'currentDomain'
    ])
  },
  methods:{
    isSystemRoleAndSelfDoaim(){
      let flag = false;
      const whiteName = ["everiaction.com"]
      if (whiteName.some(item => window.location.hostname.indexOf(item) > -1) && getSystemRole()) {
        flag=true;
      }
      return flag;
    },
    getCurrentLangLabel:getCurrentLangLabel,
    openHelpInfo(){
      let url = this.helpLink // "https://www.yuque.com/books/share/758b42fc-71c2-47f3-bd26-e83b08043e3f?# 《云平台帮助手册V3.0》"
      window.open(url)
    },
    openNormalFormula() {
      openFloatDialog('normalFormula', this.$t('常用公式'), {})
    },
    goBigDataLink(link){
      let domain = window.location.pathname
      let domainPrefix = getDomainPrefix(domain)
      window.open(link+"&projectId="+this.projectInfo.id+"&token="+getToken()+"&realm="+domainPrefix)
    },
    logoutUser(){
      this.LogOut()
    },
    goLocation(){
      console.log(this.projectInfo);
      let link = goHome(this.projectInfo, this.buttonPageObj['location'])
      this.goPage(link)
    },
    goPage(path){
      this.$router.push(path)
    },
    updateStatus(data){
      this.$refs.warnBox.getAlertInfo()
      this.currentWarningData.status = data
      this.showWarningModal = false
    },
    getRealUrl(url){
      let str = "/image/"
      if(url.indexOf(str)== 0){
        return url
      }else{
        return imgBaseUrl + url
      }
      return item
    },
    getProjectUnits(){
      this.projectUnits = []
      if(this.projectInfo.id){
        this.$httpProj.get('proj/project/mapDetail?hideLoadding=1&projectId='+this.projectInfo.id).then(res=>{
          let weather = res.data.weather ? res.data.weather : null
          this.$store.dispatch('setWeather',weather)
        })
        this.$httpProj.get("proj/customUnit/findByProjectId?hideLoadding=1&projectId="+this.projectInfo.id).then(res => {
          this.projectUnits = res.data ? res.data : []
        })
      }
    },
    /*获取图片前缀*/
    getImgUrl(path){
      let str = "http"
      let str2 = "data:image"
      let ret = ''
      if(path.indexOf(str)== 0 || path.indexOf(str2) == 0){
        ret = path
      }else{
        ret = imgBaseUrl + path
      }
      return ret
    },
    createProject() {
      this.$router.push("/platform/createProject")
    },
    projectList(){
      this.$router.push("/platform/projectList")
    },
    personCenter(){
      this.$router.push("/platform/personCenter")
    },
    setBodyTheme(theme){
      document.body.className = `${theme} ${this.language}`
    },
    changeTheme(theme){
      this.theme = theme;
      this.setThemeStore(theme)
      this.setBodyTheme(this.theme)
      this.$Bus.$emit("changeTheme",theme)
    },
    switchLang(language){
      let value = this.language = language
      this.$i18n.locale = value;
      this.setLanguage(value)
      window.location.reload()
    },
    clickItem(item){
      this.showWarningModal = true;
      this.currentWarningData = item
    },
    changeDomainPrefix(domain) {
      console.log(window.location, domain)
      let domainPrefix = getDomainPrefix(window.location.pathname)
      this.setCurrentDomain(domain)
      if(domainPrefix !== domain) {
        if(domain) {
          const url = window.location.origin + '/' + domain + '/' + window.location.hash
          window.location.href = url
        }else{
          const url = window.location.origin + '/' + window.location.hash
          window.location.href = url
        }
      }
    },
    dragend(e) {
      this.$refs.checkRef.style.top = `${e.y - this.top}px`
      this.$refs.checkRef.style.left = `${e.x - this.left}px`
    },
    dragendStart(e) {
      console.log(e);
      this.top = e.offsetY
      this.left = e.offsetX
    },
    handleShowOrHidderCheckDialog(isShowCheckDialog) {
      this.$store.commit('SET_CHECKDIALOG', isShowCheckDialog)
      setTimeout(() => {
        if (!this.checkPageCount) {
          this.$refs.checkDataRef.init()
          this.checkPageCount = true
        }
      }, 1000);
    },
    updataCheckPage() {
      this.$store.commit('SET_CHECKDIALOG', false)
      this.checkPageCount = false
    },
    ...mapMutations({
      setCurrentDomain: 'SET_CURRENTDOMAIN'
    }),
    ...mapActions({
      LogOut: 'LogOut',
      setThemeStore:'setThemeStore',
      setLanguage:'setLanguage'
    })
  }
}
</script>

<style lang="scss">
.icon-shujudaping{
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  position: relative;
  .domain-list {
    display: none;
    position: absolute;
    left: 0;
    top:0;
    transform: translateX(-100%);
    max-height: 200px;
    overflow: auto;
    li {
      white-space: nowrap;
      padding: 0 10px;
    }
  }
  &:hover {
    .domain-list {
      display: block;
    }
  }
}
</style>
<style lang="scss" scoped>

.check-btn-wapper {
  width: 92px;
  height: 92px;
  position: absolute;
  right: 30px;
  bottom: 30px;
  cursor: pointer;
  z-index: 9999;
  img{
    width: 100%;
    height: 100%;
  }
}
.header-content{
  width:100%;
  height:100%;
  padding:0 0 0 20px;
  box-sizing: border-box;
  display: flex;
  .logo{
    height: 33px;
    margin-top: 11px;
  }
  .name{
    height: 100%;
    display: flex;
    margin-left: 10px;
    margin-right: 20px;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }
  .block{
    //flex:1;
  }
  .user-flex{
    flex:1;
    display: flex;
    justify-content: flex-end;
    .el-tooltip,.el-dropdown-link{
      line-height: 40px;
    }
    .warning-bell{
      position:relative;
      margin-right:30px;
      display: flex;
      align-items: center;
      .warning_tip{
        /*width: 23px;*/
        height: 18px;
        line-height: 18px;
        text-align: center;
        border-radius: 10px;
        border: 1px solid #fff;
        background: #FFAA25;
        position: absolute;
        top: 0px;
        left: 5px;
        z-index: 999;
        padding:0 6px;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .screenfull{
      margin: 0;
      height: 100%;
      display: flex;
      align-items: center;
    }
    .home{
      display: flex;
      align-items: center;
      height: 100%;
    }
    .user-info{
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
}
.c_lang{
  width: 16px;
  height: 16px;
  line-height: 16px!important;
  text-align: center;
  display: inline-block;
  background: #ffffff;
  color: black;
  font-size: 12.5px;
  font-weight: 600;
  margin-top: 12px;
}
.name-over{
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
}
</style>